const main_state = {
  popup_open: false,
  popup_type: false,
  toast_open: false,
  toast_msg: "",
};

const modal = (state = main_state, action) => {
  switch (action.type) {
    case "TOGGLE_POPUP":
      return { ...state, popup_open: action.bool, popup_type: action.tipe };
    case "TOGGLE_TOAST":
      return { ...state, toast_open: action.bool, toast_msg: action.msg };
    default:
      return state;
  }
};

export default modal;
